// extracted by mini-css-extract-plugin
export default {"leaderboard":"Leaderboard_leaderboard__v5Apf","radioGroup":"Leaderboard_radioGroup__UHISa"};